// @ts-nocheck
import { useSelector } from 'react-redux';

import { FBoxContainer, FHMUIDataTable } from '../../../base';
import { FORTA_WHITE } from '../../../../utils/colors';
import { sessionsInClaimColDefs, sessionsInClaimTableOptions } from './config';
import { getSessionsInClaimsData } from '../claims/utils';

import type { RootState } from '../../../../store';

function SessionsInClaimTable() {
  const { current: claim } = useSelector((state: RootState) => state.claims);

  return (
    <FBoxContainer dataTestId="sessionsInClaimContainer" sx={{ boxShadow: 'none' }}>
      <FHMUIDataTable
        containerStyles={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          maxHeight: '570px',
          backgroundColor: FORTA_WHITE,
          backgroundSize: '100%',
          boxShadow: 'none',
          borderRadius: '10px',
          margin: 0,
          overflowY: 'auto',
        }}
        title=""
        data={getSessionsInClaimsData(claim)}
        columns={sessionsInClaimColDefs}
        options={sessionsInClaimTableOptions}
      />
    </FBoxContainer>
  );
}

function SessionsInClaim() {
  return <SessionsInClaimTable />;
}

export default SessionsInClaim;
